import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { FaUser, FaSignOutAlt, FaUsers, FaEye, FaFileInvoiceDollar, FaTachometerAlt } from 'react-icons/fa';
import AuthContext from '../../context/AuthContext';

const Header = () => {
  const { isAuthenticated, logout, user, isAdmin } = useContext(AuthContext);
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const onLogout = () => {
    logout();
    navigate('/login');
  };

  const closeNavbar = () => setExpanded(false);

  const authLinks = (
    <>
      <Nav.Link as={Link} to="/dashboard" onClick={closeNavbar}>
        <FaTachometerAlt className="me-1" /> Dashboard
      </Nav.Link>
      <Nav.Link as={Link} to="/customers" onClick={closeNavbar}>
        <FaUsers className="me-1" /> Customers
      </Nav.Link>
      <Nav.Link as={Link} to="/prescriptions" onClick={closeNavbar}>
        <FaEye className="me-1" /> Prescriptions
      </Nav.Link>
      <Nav.Link as={Link} to="/invoices" onClick={closeNavbar}>
        <FaFileInvoiceDollar className="me-1" /> Invoices
      </Nav.Link>
      {isAdmin() && (
        <Nav.Link as={Link} to="/users" onClick={closeNavbar}>
          <FaUsers className="me-1" /> Users
        </Nav.Link>
      )}
      <NavDropdown title={<><FaUser className="me-1" /> {user && user.name}</>} id="basic-nav-dropdown">
        <NavDropdown.Item as={Link} to="/profile" onClick={closeNavbar}>
          Profile
        </NavDropdown.Item>
        <NavDropdown.Divider />
        <NavDropdown.Item onClick={onLogout}>
          <FaSignOutAlt className="me-1" /> Logout
        </NavDropdown.Item>
      </NavDropdown>
    </>
  );

  const guestLinks = (
    <>
      <Nav.Link as={Link} to="/login" onClick={closeNavbar}>
        Login
      </Nav.Link>
      <Nav.Link as={Link} to="/register" onClick={closeNavbar}>
        Register
      </Nav.Link>
    </>
  );

  return (
    <Navbar bg="primary" variant="dark" expand="lg" fixed="top" expanded={expanded}>
      <Container>
        <Navbar.Brand as={Link} to={isAuthenticated ? '/dashboard' : '/'}>
          Optical Data Manager
        </Navbar.Brand>
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav" 
          onClick={() => setExpanded(expanded ? false : true)} 
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {isAuthenticated ? authLinks : guestLinks}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
